import { BlockUI } from "primereact/blockui";
import { ProgressBar } from "primereact/progressbar";
import { useEffect, useState } from "react";
import { useRpc } from "../../context/RpcContext";
import { RpcClient } from "../../services/rpc-socket/rpcClient";
import styles from "./BlockUI.module.css";
import { useAuthContext } from "../../context/AuthContext";

export const BlockUi = () => {
  const { subscribe, unsubscribe, wsOpened } = useRpc();
  const [blockUI, setBlockUI] = useState(false);
  const [message, setMessage] = useState("Пожалуйста, подождите...");
  const [progress, setProgress] = useState(0);
  const { reauth } = useAuthContext();

  useEffect(() => {
    if (!wsOpened) {
      setBlockUI((prev) => true);
      setMessage("Подключение к серверу...");
    } else {
      const timer = setTimeout(() => {
        setBlockUI((prev) => false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [wsOpened]);

  useEffect(() => {
    const handleLockUnlock = (params: {
      blockUI: string;
      caption?: string;
      progress?: number;
    }) => {
      if (params.blockUI === "true") {
        setMessage((prev) => params.caption || "Пожалуйста, подождите...");
        setProgress((prev) => params.progress || 0);
        setBlockUI((prev) => true);
      } else if (params.blockUI === "false") {
        setBlockUI((prev) => false);
        setProgress((prev) => 0);
      }
    };

    const subscribeWithRetry = async (
      eventName: string,
      maxRetries = 5,
      delay = 1000
    ) => {
      let attempt = 0;
      while (attempt < maxRetries) {
        console.log(
          `Попытка подписки на ${eventName}, попытка №${attempt + 1}`
        );
        try {
          await RpcClient.call("subscribe", "lock_unlock");
          subscribe("lock_unlock", handleLockUnlock);
          const token = localStorage.getItem("authToken");
          if (token) reauth({ token });
          console.log(`Подписка на ${eventName} успешно выполнена`);
          break;
        } catch (error) {
          attempt++;
          console.error(
            `Попытка ${attempt} не удалась: ${(error as Error).message}`
          );

          if (attempt < maxRetries) {
            await new Promise((resolve) => setTimeout(() => resolve, delay));
            console.log(`Повторная попытка подписки на ${eventName}...`);
          } else {
            console.error(
              `Не удалось подписаться на ${eventName} после ${maxRetries} попыток`
            );
          }
        }
      }
    };

    subscribeWithRetry("lock_unlock", 5, 1000);

    return () => {
      unsubscribe("lock_unlock", handleLockUnlock);
    };
  }, [subscribe, unsubscribe]);

  return (
    <BlockUI
      blocked={blockUI}
      fullScreen
      template={
        <div className={styles["block-ui-content"]}>
          <div className={styles["progress-container"]}>
            <ProgressBar
              value={progress}
              mode={progress > 0 ? "determinate" : "indeterminate"}
              pt={{
                root: { className: styles["progress-root"] },
                value: { className: styles["progress-value"] },
              }}
              className={styles["custom-progress-bar"]}
            />
            <h3 className={styles["message-text"]}>{message}</h3>
          </div>
        </div>
      }
    />
  );
};
